var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['main-navbar', 'bg-white', _vm.stickyTop ? 'sticky-top' : '']},[_c('d-navbar',{staticClass:"align-items-end flex-md-nowrap p-0",attrs:{"type":"light"}},[_c('navbar-search'),_c('navbar-nav'),_c('navbar-toggle')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }